import { LANG_VALUES_MAP } from '@/utils/constants'

export default {
  computed: {
    lang() {
      return this.$store.state.lang
    },
    i18nLabel() {
      return (labelObj) => {
        if (!labelObj) return ''

        const currentValues = LANG_VALUES_MAP.get(this.lang)
        if (!currentValues) return labelObj[this.lang]

        const label = labelObj[currentValues[0]] || labelObj[currentValues[1]] || ''
        return label
      }
    },
  },
}
